export default __webpack_public_path__ + "static/media/57.7673cfa7.jpeg";